/**
 * URL of the pdf.js worker, resolved out of our own `pdfjs-dist` dependency
 * and served from our own origin.
 *
 * Passed to every `<PdfLoader>` we render, primarily to keep the worker off
 * `unpkg.com`: without a `workerSrc` prop the library falls back to a
 * hardcoded `https://unpkg.com/pdfjs-dist@4.4.168/build/pdf.worker.min.mjs`
 * — a third-party CDN in the critical path of every document view. It also
 * removes one of `load()`'s two unguarded reads (`globalThis.pdfJs`).
 *
 * Note this does NOT close the url-change race on its own. `load()` writes
 * `GlobalWorkerOptions.workerSrc = workerSrc`, and `GlobalWorkerOptions` is
 * itself a module-scoped binding the library only assigns after its async
 * `import('pdfjs-dist')` resolves — so an in-place url change landing in
 * that window still throws, just as "Cannot set properties of undefined"
 * instead of the original "can't access property legacy". The race is
 * closed by `key={url}` on `<PdfLoader>` (see PdfViewer), which turns a
 * document change into a remount through the guarded componentDidMount
 * path instead of an update through the unguarded componentDidUpdate one.
 *
 * `new URL(<bare specifier>, import.meta.url)` is resolved and emitted as an
 * asset by both bundlers that consume this lib — Vite (admin) and webpack /
 * Turbopack (sales, media-player).
 */
export const PDF_WORKER_SRC = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).href;
